import AuthLogic from '../../functions/logic/Auth';

const logDetail = async (secuenciaPersonal, accion, detalleAccion, pathModulo, usuarioCreacion) => {
  const dataToSave = { secuenciaPersonal, accion, detalleAccion, pathModulo, usuarioCreacion };
  try {
    await AuthLogic.SaveLogLogic(dataToSave);
  } catch (error) {
    console.error('Error in logDetail', error);
  }
}

const LogDetail = {
  logDetail
}

export default LogDetail

